import type { RouteRecordRaw } from 'vue-router';

const i18n = import.meta.glob<{ default: Record<string, unknown> }>('./i18n/*.ts');

// Màn đáp của link verify trong mail — cùng dạng với reset-password nên KHÔNG khai `onlyGuest`:
// flow success tự `setAuthenticationCookies` sang account chủ token (`useConfirmEmail.ts`).
export const confirmEmailRoutes = {
  name: 'verify-email',
  path: 'confirm-email',
  components: {
    default: () => import('./ConfirmEmail.vue'),
    brand: () => import('./ConfirmEmailBrand.vue'),
  },
  meta: { i18n },
} satisfies RouteRecordRaw;
